import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './EntertainmentOption.scss';

const EntertainmentOption = ({
  label = '',
  checked = false,
  color = '',
  areSpacesAvailable = true,
  isClashedEvent = false,
  disabled,
  onOptionClick,
  isAlreadyBooked,
  isAllowedToBookEveningShow = true,
}) => (
  <div
    className={classnames('option', checked && 'checked', color && color, disabled && 'grey-background')}
    onClick={onOptionClick}
  >
    {!!label && <div className="option-label">{label}</div>}
    {!checked && !areSpacesAvailable && !isAlreadyBooked && (
      <div className="option-no-spaces">No spaces available</div>
    )}
    {isClashedEvent && <div className={classnames('option-clash', checked && 'checked')}>This overlaps with an existing booking</div>}
    {!isAllowedToBookEveningShow && !checked && <div className="option-no-spaces">You already have an evening show booked on this day</div>}
  </div>
);

EntertainmentOption.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  color: PropTypes.string,
  isClashedEvent: PropTypes.bool,
  disabled: PropTypes.bool,
  onOptionClick: PropTypes.func.isRequired,
  areSpacesAvailable: PropTypes.bool,
  isAlreadyBooked: PropTypes.bool,
  isAllowedToBookEveningShow: PropTypes.bool,
};

export default EntertainmentOption;
